import { render, staticRenderFns } from "./MessageActionV2.vue?vue&type=template&id=2f3f6362"
import script from "./MessageActionV2.vue?vue&type=script&lang=js"
export * from "./MessageActionV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports